
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import ClientList from './List';
import ClientDetail from './Detail';
import ClientAdd from './Add';
import ClientEdit from './Edit';
import ClientDetailOrders from './DetailOrders';
import ClientDetailContracts from './Contract/DetailContracts';
import ClientDetailChanges from './DetailChanges';

export default class ClientRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/client" exact component={ClientList} />
        <Route path="/client/add" component={ClientAdd} />
        <Route path="/client/:id/edit" component={ClientEdit} />
        <Route path="/client/:id/orders" component={ClientDetailOrders} />
        <Route path="/client/:id/contracts" component={ClientDetailContracts} />
        <Route path="/client/:id/changes" component={ClientDetailChanges} />
        <Route path="/client/:id" component={ClientDetail} />
      </Switch>
    );
  }
}
